import { css } from '@emotion/react'
import { useUser } from '../../../../contexts/AuthContext'
import { User } from '../../../../types'
import { SelectedContactPersonRow } from '../containers/search-result'
import { ContactPersonsState } from '../reducers/contactPerson'
import { OptionDropdown } from '../../../view/OptionDropdown'
import { OptionDropdownItem } from '../../../view/OptionDropdownItem'

type Props = {
  selectedCompanyContactPerson: SelectedContactPersonRow | null
  setSelectedCompanyContactPerson: React.Dispatch<
    React.SetStateAction<SelectedContactPersonRow | null>
  >
  contactPersons: ContactPersonsState['data']
  onSelectContactPersonBlank: (companyId: string, user: User) => void
  onSelectContactPerson: (
    id: number,
    companyId: string,
    firstName: string,
    lastName: string,
    user: User
  ) => void
}

export const CompanyContactPersonsOptionDropDown: React.FC<Props> = ({
  selectedCompanyContactPerson: selectedCompanyContactPerson,
  setSelectedCompanyContactPerson: setSelectedCompanyContactPerson,
  contactPersons,
  onSelectContactPersonBlank,
  onSelectContactPerson,
}) => {
  const user = useUser()
  return selectedCompanyContactPerson != null ? (
    <OptionDropdown
      _css={css`
        margin-top: 16px;
        max-height: 280px;
        overflow-y: auto;
        top: ${selectedCompanyContactPerson.target &&
        selectedCompanyContactPerson.target.getBoundingClientRect().top +
          window.pageYOffset +
          37}px;
        left: ${selectedCompanyContactPerson.target &&
        selectedCompanyContactPerson.target.getBoundingClientRect().left +
          window.pageXOffset}px;
      `}
      open={true}
      hideTopArrow
    >
      <OptionDropdownItem
        label="（空白）"
        condition={
          selectedCompanyContactPerson.selectedContactPersonFirstName == null &&
          selectedCompanyContactPerson.selectedContactPersonLastName == null
        }
        idx={0}
        handleSet={() => {
          onSelectContactPersonBlank(
            selectedCompanyContactPerson.companyId,
            user
          )
          setSelectedCompanyContactPerson(null)
        }}
      />
      {contactPersons.map(
        // TODO: name ではなく id で突き合わせる
        (p: { id: number; firstName: string; lastName: string }) => (
          <OptionDropdownItem
            key={p.id}
            condition={
              p.firstName ===
                selectedCompanyContactPerson.selectedContactPersonFirstName &&
              p.lastName ===
                selectedCompanyContactPerson.selectedContactPersonLastName
            }
            idx={0}
            handleSet={() => {
              onSelectContactPerson(
                p.id,
                selectedCompanyContactPerson.companyId,
                p.firstName,
                p.lastName,
                user
              )
              setSelectedCompanyContactPerson(null)
            }}
            label={`${p.lastName} ${p.firstName}`}
          />
        )
      )}
    </OptionDropdown>
  ) : (
    <></>
  )
}
